import { Component, OnChanges, OnDestroy } from '@angular/core';
import { BamboraCheckoutService } from '../../services/bambora-checkout.service';
import { PaymentStorageService } from '../../services/payment-storage.service';
import { PaymentApiService } from '../../../api-services/services/payment-api.service';
import { BamboraPaymentComponent } from '../bambora-payment/bambora-payment.component';

@Component({
  standalone: false,
  selector: 'exclusive-bambora-payment',
  templateUrl: './exclusive-bambora-payment.component.html',
  styleUrls: ['./exclusive-bambora-payment.component.scss'],
})
export class ExclusiveBamboraPaymentComponent extends BamboraPaymentComponent implements OnChanges, OnDestroy {
  constructor(
    _paymentApi: PaymentApiService,
    _storage: PaymentStorageService,
    _bamboraCheckout: BamboraCheckoutService,
  ) {
    super(_paymentApi, _storage, _bamboraCheckout);
  }
}
